// extracted by mini-css-extract-plugin
module.exports = {"toggle":"style__toggle___ebx0q","toggleBtn":"style__toggleBtn___3Orxb","toggleLabel":"style__toggleLabel___1ti_m"};